import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ThemeProvider } from "./context/ThemeContext";
import { DownloadAssetsProvider } from "./context/DownloadAssetsContext";
import DownloadQueuePanel from "./Components/Common/DownloadQueuePanel";
import { SocketProvider } from "./context/SocketContext";
import { SOCKET_URL } from "./Constant";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ThemeProvider>
    {/* <SocketProvider socketUrl={SOCKET_URL}> */}
      <DownloadAssetsProvider>
        <ToastContainer
          position="top-center"
          autoClose={2000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
        />
        <App />
        <DownloadQueuePanel />
      </DownloadAssetsProvider>
    {/* </SocketProvider> */}
  </ThemeProvider>
);
